import { tokens } from '@welbe/web-design-system';
import styled, { css } from 'styled-components';
import {
	ButtonStatusTypes,
	SectionCellTypes,
	SectionHeaderTypes,
	SectionInfoTypes,
	SectionTypes,
} from './CollaboratorDetails.types';

export const Container = styled.div`
	width: 100%;
	padding: 20px;
`;

export const LoadingContainer = styled.div`
	width: 100%;
	height: 40vh;
	display: grid;
	place-items: center;
`;

export const ActionContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 20px;
	width: 100%;
`;

export const Section = styled.div<SectionTypes>`
	display: grid;
	animation: ${({ extraPadding }) => (extraPadding ? 'fadeIn 0.8s' : 'none')};

	${({ columns }) =>
		columns
			? css`
					grid-template-columns: repeat(${columns}, 1fr);
			  `
			: css`
					grid-template-columns: 1fr 1fr;

					@media (min-width: 1080px) {
						grid-template-columns: 1fr 1fr 1fr;
					}

					@media (max-width: 860px) {
						grid-template-columns: 1fr;
					}
			  `}

	width: 100%;
	min-height: 130px;
	gap: 50px 20px;
	padding: ${({ extraPadding }) => (extraPadding ? '50px 0 25px 0' : '25px 0')};
	justify-content: center;
	${({ noBorder }) =>
		!noBorder &&
		css`
			border-bottom: 1px solid #d8dee6;
		`};
`;

export const SectionHeader = styled.p<SectionHeaderTypes>`
	font-weight: 500;
	font-size: 14px;
	line-height: 20px;
	align-items: center;
	color: ${({ color }) => color || '#64778f'};
`;

export const SectionInfo = styled.p<SectionInfoTypes>`
	font-weight: ${({ variant }) => (variant ? 500 : 600)};
	font-size: 16px;
	line-height: 22px;
	display: flex;
	align-items: center;
	color: #64778f;
	${({ variant }) =>
		!variant &&
		css`
			margin-top: 20px;
		`};
`;

export const SectionCell = styled.div<SectionCellTypes>`
	${({ span }) => span && `grid-column: ${span}`};
	align-self: center;
`;

export const FormButton = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: auto 1fr;
	height: 70px;
	background: #f5f7fa;
	border-radius: 6px;
	max-width: 320px;
	width: 100%;
	padding: 14px;
	place-items: center;
	justify-items: start;
	transition: all 0.2s ease-in-out;
	cursor: pointer;

	&:hover {
		background: #e9edf3;
	}
`;

export const ProgressContainer = styled.div`
	position: absolute;
	top: -50%;
	left: 80%;
	background: ${tokens.color_white};
	border-radius: 50%;
	width: 60px;
	height: 60px;
	text-align: center;
`;

export const ButtonDetails = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	margin-left: 10px;
`;

export const ButtonTitle = styled.p<{ fontSize?: string }>`
	font-weight: 600;
	font-size: ${({ fontSize }) => fontSize || '16px'};
	line-height: 22px;
	color: #64778f;
	white-space: nowrap;
	overflow: hidden;
	width: 100%;
`;

export const ButtonStatus = styled.p<ButtonStatusTypes>`
	font-weight: 600;
	font-size: 16px;
	line-height: 22px;
	display: flex;
	align-items: center;
	color: ${({ danger }) =>
		danger ? tokens.color_toast_error : tokens.color_primary};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;
